import { render, staticRenderFns } from "./question1.vue?vue&type=template&id=84bb40c8&scoped=true&"
import script from "./question1.vue?vue&type=script&lang=js&"
export * from "./question1.vue?vue&type=script&lang=js&"
import style0 from "./question1.vue?vue&type=style&index=0&id=84bb40c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bb40c8",
  null
  
)

export default component.exports